import jQuery from 'jquery';

// This file loads and exposes jquery before angular gets loaded, making sure that angular uses jQuery
window.jQuery = jQuery;
window.$ = jQuery;

/**
 * Fix for jQuery htmlPrefilter vulnerability in 3.4.1
 * @see https://jquery.com/upgrade-guide/3.5/
 */
var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi;
jQuery.htmlPrefilter = function( html ) {
    return html.replace( rxhtmlTag, "<$1></$2>" );
};

// Ensure ckeditor files are not loaded by relative path
window.CKEDITOR_BASEPATH = '/ckeditor/';

// Now that jquery is available, load angular
require('angular');
